import { useState } from 'react';
import create from 'zustand';

interface SearchState {
	searchTerm: string;
	previousSearchTerm: string;
	filters: Record<string, any>;
	setSearchTerm: (term: string) => void;
	setPreviousTerm: (term: string) => void;
	setFilters: (filters: Record<string, any>) => void;
	resetSearch: () => void;
	reset: () => void;
}

const initialState = {
	searchTerm: '',
	previousSearchTerm: '',
	filters: {},
};

export const useSearchStore = create<SearchState>((set) => ({
	...initialState,
	setSearchTerm: (term) => set({ searchTerm: term }),
	setFilters: (filters) => set({ filters }),
	setPreviousTerm: (term) => set({ previousSearchTerm: term }),
	resetSearch: () => set(initialState),
	reset: () => set(initialState),
}));